import React, { memo, useCallback, useMemo } from "react";
import { FaChevronRight } from "react-icons/fa";
import { BRAND_CLICK_TARGET } from "../../event_conf";
import useTrack, { eventTypes } from "../../hooks/useTrack";
import accessibilityProvider from "../../utils/accessibilityProvider";
import linkProvider from "../../utils/linkProvider";
import getParsedRedirectUrl from "../../utils/getParsedRedirectUrl";
import "./brand-row-header.css";

const BrandRowHeader = memo(({ brand, upsell = false, defaultEventProps }) => {
	const {
		logo_url: logoUrl,
		single_liner: singleLiner,
		masked_url: brandUrl,
		name,
	} = useMemo(() => brand || {}, [brand]);

	const track = useTrack();

	const brandRedirectUrl = getParsedRedirectUrl({ brand, upsell });

	const handleClick = useCallback(() => {
		track(eventTypes.CLICK_BRAND, {
			...defaultEventProps,
			brand_redirect_link: brandRedirectUrl,
			target: BRAND_CLICK_TARGET.DISCO_FEED_1,
		});
	}, [defaultEventProps, brandRedirectUrl, track]);

	return (
		<div className="widget-brand-header">
			<a
				{...linkProvider({
					href: brandRedirectUrl,
					injectElement: false,
				})}
				{...accessibilityProvider({
					name: `${name} image`,
				})}
				onClick={handleClick}
			>
				<img
					src={logoUrl}
					alt=""
					className="widget-brand-header-image"
					data-testid="widget-brand-header-image"
				/>
			</a>
			<a
				{...linkProvider({
					href: brandRedirectUrl,
					injectElement: false,
				})}
				{...accessibilityProvider({
					name: `${name} Products`,
				})}
				onClick={handleClick}
				className="widget-brand-header-title"
				data-testid="widget-brand-header-title"
			>
				<div
					className="widget-brand-header-title-name"
					{...accessibilityProvider()}
				>
					{name}
				</div>
				{singleLiner && (
					<div
						className="widget-brand-header-title-desc"
						{...accessibilityProvider()}
					>
						{singleLiner}
					</div>
				)}
			</a>
			{brandUrl && (
				<a
					className="widget-brand-header-cta widget-brand-header-btn"
					onClick={handleClick}
					{...linkProvider({
						href: brandRedirectUrl,
						injectElement: false,
					})}
					{...accessibilityProvider({
						name: `Visit ${name}`,
					})}
				>
					<span className="widget-brand-header-cta-text">
						Visit Shop
					</span>
					<FaChevronRight />
				</a>
			)}
		</div>
	);
});

export default BrandRowHeader;
